import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { InputGroup } from '@/components/ui/input-group';
import styles from '../UnifyOnboarding.module.scss';

export const OAuthConnection = ({ provider, oauthParams, onParamsChange, onConnect, isLoading, isDisabled }) => {
	const [errors, setErrors] = useState({});

	if (!provider || provider.connection !== 'oauth') {
		return null;
	}

	const params = provider.connect?.params || [];

	const handleParamChange = (name, value) => {
		onParamsChange({ ...oauthParams, [name]: value });
		if (errors[name]) {
			setErrors((prev) => ({ ...prev, [name]: null }));
		}
	};

	const handleConnect = () => {
		const newErrors = {};
		for (const param of params) {
			const value = oauthParams[param.name] || '';
			if (param.regex && !new RegExp(param.regex).test(value)) {
				newErrors[param.name] = param.helpText || 'Invalid value';
			}
		}

		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return;
		}

		onConnect();
	};

	const hasParams = params.length > 0;
	const allParamsFilled = !hasParams || params.every((p) => oauthParams[p.name]);

	return (
		<>
			{hasParams &&
				params.map((param) => (
					<InputGroup key={param.name} label={param.label}>
						<Input
							value={oauthParams[param.name] || ''}
							onChange={(e) => handleParamChange(param.name, e.target.value)}
							placeholder={param.helpText}
							disabled={isLoading || isDisabled}
							className={errors[param.name] ? styles.inputError : ''}
						/>
						{errors[param.name] ? (
							<p className={styles.errorText}>{errors[param.name]}</p>
						) : (
							param.helpText && <p className={styles.helperText}>{param.helpText}</p>
						)}
					</InputGroup>
				))}
			<p className={styles.helperText}>
				Click the button below to connect your {provider.label} account. You&apos;ll be redirected to authorise the connection.
			</p>
			<Button onClick={handleConnect} disabled={isLoading || isDisabled || !allParamsFilled} className={styles.submitButton}>
				{isLoading ? 'Connecting...' : `Connect to ${provider.label}`}
			</Button>
		</>
	);
};
